module.exports = __webpack_public_path__ + "static/media/report_nav.b82b7cb6.svg";